import { Component, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './auth.service';
import { QuibblService } from './quibbl.service';
import { Angulartics2GoogleAnalytics } from 'angulartics2';

@Component({
    selector: 'quibbl-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  public isPolitics = false;
  public isSports = false;
  public isEntertainment = false;

  public isNorthwestern = false;
  public isHarvard = false;
  public isColumbia = false;

  public routerSubscription;
  public superUserSubscription;
  public userIsSuperUser = false;

  public notificationSubscription;
  public notificationCount = 0;
  public newNotifications = [];
  public oldNotifications = [];

  @ViewChild('scroller') private scrollContainer: ElementRef;

    constructor(private router: Router,
                public auth: AuthService,
                private _qb: QuibblService,
                angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {

      auth.isLoggedIn.subscribe((value: boolean) => {
        if(!value && !auth.isLoggingIn) {
          if(this.router.url != '/marchmadness') {
            console.log("Not logged in; redirecting to /login");
            this.router.navigate(['/login']);
            return;
          }
        }

        else if(value) {

          if(this.notificationSubscription) this.notificationSubscription.unsubscribe();
          this._qb.getNotifications().subscribe(notifications => {
            if(notifications && notifications.notifications && notifications.notification_count) {
              this.notificationCount = notifications.notification_count;
              this.newNotifications = Object.values(notifications.notifications);
            }

            else {
              this.notificationCount = 0;
              this.newNotifications = [];
            }
          });

          if(this.superUserSubscription) this.superUserSubscription.unsubscribe();
          this.superUserSubscription = auth.userIsSuperUser.subscribe((superUser: boolean) => {
            this.userIsSuperUser = superUser;

            if(this.routerSubscription) this.routerSubscription.unsubscribe();
            this.routerSubscription = router.events.subscribe((val) => {
                if(val instanceof NavigationEnd) {
                  if(val.url.startsWith("/login") && auth.isLoggedIn.value) {
                    //console.log("Logged in and trying to login; redirecting to /home");
                    this.router.navigate(['/home']);
                  }

                  if(val.url.startsWith("/admin") && !superUser) {
                    console.log("You don't have permission to do that.");
                    this.router.navigate(['/home']);
                  }

                  this.isPolitics = false;
                  this.isSports = false;
                  this.isEntertainment = false;
                  this.isNorthwestern = false;
                  this.isHarvard = false;
                  this.isColumbia = false;

                  if(val.url.startsWith("/category/entertainment")) {
                    this.isEntertainment = true;
                  }

                  else if(val.url.startsWith("/category/sports")) {
                    this.isSports = true;
                  }

                  else if(val.url.startsWith("/category/politics")) {
                    this.isPolitics = true;
                  }

                  else if(val.url.startsWith("/category/northwestern")) {
                    this.isNorthwestern = true;
                  }

                  else if(val.url.startsWith("/category/harvard")) {
                    this.isHarvard = true;
                  }

                  else if(val.url.startsWith("/category/columbia")) {
                    this.isColumbia = true;
                  }

                  else if(val.url.startsWith("/about") || val.url.startsWith("/terms")) {
                    try {
                      this.scrollContainer.nativeElement.scrollTop = 0;
                      window.scrollTo(0,0);
                    } catch(err) { }
                  }

                }
            });
          });

        }

      });

      if(this.routerSubscription) this.routerSubscription.unsubscribe();
      this.routerSubscription = router.events.subscribe((val) => {
          if(val instanceof NavigationEnd) {
            this.isPolitics = false;
            this.isSports = false;
            this.isEntertainment = false;
            this.isNorthwestern = false;
            this.isHarvard = false;
            this.isColumbia = false;

            if(val.url.startsWith("/category/entertainment")) {
              this.isEntertainment = true;
            }

            else if(val.url.startsWith("/category/sports")) {
              this.isSports = true;
            }

            else if(val.url.startsWith("/category/politics")) {
              this.isPolitics = true;
            }

            else if(val.url.startsWith("/category/northwestern")) {
              this.isNorthwestern = true;
            }

            else if(val.url.startsWith("/category/harvard")) {
              this.isHarvard = true;
            }

            else if(val.url.startsWith("/category/columbia")) {
              this.isColumbia = true;
            }

            else if(val.url.startsWith("/about") || val.url.startsWith("/terms")) {
              try {
                this.scrollContainer.nativeElement.scrollTop = 0;
                window.scrollTo(0,0);
              } catch(err) { }
            }

          }
      });
    }

    menuItems = [
      {
        label: "Home",
        link: "home",
        id: "home"
      },
      {
        label: "Categories",
        children: [
          {
            label: "Politics",
            link: "category/politics",
            id: "politics"
          },
          {
            label: "Entertainment",
            link: "category/entertainment",
            id: "entertainment"
          },
          {
            label: "Sports",
            link: "category/sports",
            id: "sports"
          }
        ]
      },
      // {
      //   label: "Communities",
      //   children: [
      //     {
      //       label: "Northwestern",
      //       link: "category/northwestern",
      //       id: "northwestern"
      //     },
      //     {
      //       label: "Harvard",
      //       link: "category/harvard",
      //       id: "harvard"
      //     },
      //     {
      //       label: "Columbia",
      //       link: "category/columbia",
      //       id: "columbia"
      //     }
      //   ]
      // },
      {
        label: "Leaderboard",
        link: "leaderboard",
        id: "leaderboard"
      },
      {
        label: "Daily Quibbl",
        link: "https://dailyquibbl.wordpress.com",
        id: "blog",
        type: "external"
      }
    ];

    public clearNotifications(event) {
      for(let notification of this.newNotifications) {
        this.oldNotifications.push(notification);
      }
      this.newNotifications = [];
      this.notificationCount = 0;
      this._qb.clearNotifications();
    }
}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/app.component.ts